import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  async connect() {
    await this.wait(200)
    this.element.classList.add("show")
    await this.wait(5000)
    this.element.classList.remove("show")
    await this.wait(200)
    this.element.remove()
  }

  async wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}